export default __webpack_public_path__ + "static/media/Raider's Belt of the Wicked Hearth.bb08c420.jpg";